import React from 'react'
import { Button } from 'lp-components'
import { ButtonLink } from 'components'
import { makePath, makeMembershipsPath, PATH } from 'config'

function ExistingMembershipDialog() {
  return (
    <section className="form-block-container">
      <div className="card card-medium">
        <div className="card-inner">
          <div className="group-block">
            <h3 className="group-title">Existing Member</h3>
            <p>
              We see that you already have or had a Sea Tow membership. Would
              you like to renew your existing membership? If you would like to
              add a new membership to your existing account, please{' '}
              <a href={makePath(PATH.SEATOW, PATH.CONTACT)}>contact Sea Tow</a>{' '}
              for assistance.
            </p>
            <div className="button-group">
              <Button
                className="button-primary-outline"
                onClick={() => window.location.replace(makePath(PATH.SEATOW))}
              >
                Cancel
              </Button>
              <ButtonLink
                className="button-primary"
                to={makeMembershipsPath(
                  PATH.SELECT_YOUR_MEMBERSHIP,
                  PATH.RENEW_MEMBERSHIP,
                )}
              >
                Renew Membership
              </ButtonLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ExistingMembershipDialog
